// DialogWithPdf.tsx
// NATIVE 
import React, { useEffect, useState } from 'react';

import { Dialog, DialogTitle, DialogContent, IconButton, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// import PdfViewer from '../../PdfViewer';
import { ModalSessionExpired } from '../../generics/ModalSessionExpired';

import { styled } from '@mui/material/styles';
import { PdfViewer } from '../../PdfViewer';
import { useDispatch } from 'react-redux';
import { getPdfStore } from '../../../store/files';


// import PdfViewer from './PdfViewer'; // importa el componente PDF

interface Props {
  open: boolean;
  onClose: (open: boolean) => void;
  pdfUrl: string;
}



    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    }));


export const ModalViewPdf = ({ open, onClose, pdfUrl }: any) => {


    const [modalSessionExpired, setModalSessionExpired] = useState<boolean>(false);



    // DISPATCH 
     const dispatch = useDispatch();


    // USE STATES
    const [documentPfd, setDocumentPdf] = useState<any>(null);



    const getPdfUrlFile = async(imageName:string) => { 
    

          const response =  await dispatch( getPdfStore(imageName) );
         

    

           if ( response instanceof Blob) {
              const imageUrl = URL.createObjectURL(response);
              setDocumentPdf(imageUrl);
           }

    }


    useEffect(() => {
        getPdfUrlFile(pdfUrl);
    }, [pdfUrl]);



    const onCloseModal = (open: boolean) => {
        onClose(false);
    }
     // PROPS 
//   const{ open, handleCloseDialog, buttons = false } = props;




  return (

     <React.Fragment>

     
      <ModalSessionExpired  open={modalSessionExpired}  />
      

      
      <BootstrapDialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Visor PDF
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => onCloseModal(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
            {
               documentPfd &&
               <PdfViewer fileUrl={documentPfd} />
            }
           
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
    
    
  );
}



{/* <PdfViewer fileUrl={pdfUrl} /> */}